import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=2432b3e2&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=2432b3e2&prod&scoped=true&lang=css"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=2432b3e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432b3e2",
  null
  
)

export default component.exports